export const PROFILE_TAB_KEYS = {
  INFORMATION: 'information',
  DETAILS: 'details',
  SETTINGS: 'settings',
  ADMINISTRATION: 'administration',
  NOTICES: 'notices',
  FORMS: 'forms',
} as const;
